import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TableField } from '../../models';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import ITableField = ZoneIQCalibration.ITableField;

const API = environment.ZONEIQ_CALIBRATION + '/v1/table-field';

@Injectable({
    providedIn: 'root'
})
export class TableFieldService {
    tableFields = new Map<string, ITableField>(null);
    tableFieldsList: ITableField[] = [];

    constructor(private readonly http: HttpClient) {}

    getAll() {
        return this.http.get<Response>(API).pipe(
            map(response => this.initTableFields((response as any).data)),
            tap(tableFields => {
                this.tableFields = tableFields;
            })
        );
    }

    private initTableFields(fields): Map<string, ITableField> {
        const tableFields = new Map<string, ITableField>();
        fields.forEach(field => {
            const tableField = TableField.factory(field);
            tableFields.set(field.Field, tableField);
            this.tableFieldsList.push(tableField);
        });
        return tableFields;
    }

    getById(id: number) {
        return this.tableFieldsList.find(tableField => tableField.Id === id);
    }
}
